import { render, staticRenderFns } from "./Invitation.vue?vue&type=template&id=2fd4f181&scoped=true&"
import script from "./Invitation.vue?vue&type=script&lang=js&"
export * from "./Invitation.vue?vue&type=script&lang=js&"
import style1 from "./Invitation.vue?vue&type=style&index=1&id=2fd4f181&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd4f181",
  null
  
)

export default component.exports